// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"b5ecb2ab","193":"5c7c80c6","276":"e9b4ab21","666":"7cc1f55b","738":"3437a901","821":"9a211f47"}[chunkId] + ".chunk.css";
};